/* eslint-disable no-console */
import { PubSub } from 'aws-amplify'
import { SagaIterator } from 'redux-saga'
import { all, put, takeLatest } from 'redux-saga/effects'
import { getApartment, removeApartmentSuccess } from '../actions/apartments'
import {
  getApplication,
  getApartmentApplications
} from '../actions/applications'
import {
  initializeIot,
  initializeIotFail,
  initializeIotSuccess,
  onMessage,
  onMessageFail,
  onMessageSuccess
} from '../actions/iot'
import { getStore } from '../store'
import { PayloadParameters } from '../types/payloads'

let subscriptions: any

function* handleInitializeIot(): SagaIterator {
  try {
    if (subscriptions) {
      subscriptions.unsubscribe()
    }
    const store = getStore()
    const topics = ['/apartments', '/applications']
    subscriptions = PubSub.subscribe(topics).subscribe({
      next: ({ value }: any) => {
        store.dispatch(
          onMessage({
            ...value
          })
        )
      },
      error: (error: any) => {
      },
      close: () => {
      }
    })
    yield put(initializeIotSuccess())
  } catch (error) {
    yield put(initializeIotFail())
  }
}

export interface HandleOnMessageProps {
  topic: string
  data: any
}

export function* handleOnMessage({
  payload: { topic, data }
}: PayloadParameters<HandleOnMessageProps>): SagaIterator {
  try {
    const { apartmentId, userId, applicationId, method } = data
    if (topic === '/apartments' && apartmentId && userId) {
      // console.log('handleOnMessage')
      // console.log(apartmentId)
      if (method === 'update') {
        yield put(getApartment({ userId, apartmentId }))
      } else if (method === 'delete') {
        yield put(removeApartmentSuccess(apartmentId))
      }
    } else if (topic === '/applications') {
      if (method === 'update') {
        if (apartmentId && applicationId) {
          yield put(getApplication({ apartmentId, applicationId }))
        } else if (apartmentId && !applicationId) {
          yield put(getApartmentApplications({ apartmentId }))
        }
      }
    }
    yield put(onMessageSuccess())
  } catch (error) {
    yield put(onMessageFail(error.message))
  }
}

function* watchIotActions() {
  yield all([
    takeLatest(initializeIot, handleInitializeIot),
    takeLatest(onMessage, handleOnMessage)
  ])
}

const iotSagas = [watchIotActions]

export default iotSagas
